module.exports = __webpack_public_path__ + "70c3c06f1a81b6c743ec7ac16c01e6db.pdf";